module.exports = __webpack_public_path__ + "static/media/AIYA_BLANK.25ca56a5.png";